import { render, staticRenderFns } from "./CourseScormCreate.vue?vue&type=template&id=79fad831&"
import script from "./CourseScormCreate.vue?vue&type=script&lang=ts&"
export * from "./CourseScormCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports